module.exports = __webpack_public_path__ + "static/Notion-hero-dea0229e37791ea52748c13d4d78e8aa.jpeg";